import {
  Component,
  EventEmitter,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { eq, head } from 'lodash';
import { Content } from 'app/constants';
import { SidebarList } from 'app/models';

@Component({
  selector: 'app-sidebar-list',
  templateUrl: './sidebar-list.component.html',
  styleUrls: ['./sidebar-list.component.scss'],
})
export class SidebarListComponent implements OnInit, OnChanges {
  @Input() sidebarData: SidebarList[];
  @Input() reordering = false;

  @Output() openEditDialogEmiter: EventEmitter<any> = new EventEmitter<any>();
  @Output() openSelectDialogEmiter: EventEmitter<any> = new EventEmitter<any>();
  @Output() unfollowEmiter: EventEmitter<any> = new EventEmitter<any>();
  @Output() openNewDialogEmiter: EventEmitter<void> = new EventEmitter<void>();
  @Output() reorderEmiter: EventEmitter<SidebarList[]> = new EventEmitter<
    SidebarList[]
  >();

  @ViewChild('contentItemsScroll', { static: false })
  contentItemsScroll: ElementRef<HTMLElement>;

  public listName: string;
  public isTopic: boolean;
  public isClip: boolean;

  constructor() {
    this.listName = null;
    this.isTopic = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sidebarData && changes.sidebarData.currentValue) {
      if (changes.sidebarData.currentValue.length > 0) {
        const firstItem: SidebarList = head(changes.sidebarData.currentValue);
        this.isTopic = eq(firstItem.parentName, Content.Topic);
        this.isClip = eq(firstItem.parentName, Content.ContentItem);
      }
      this.scrollTop();
    }
  }

  ngOnInit() {}

  openSelectDialog(item) {
    this.openSelectDialogEmiter.emit(item.parentObject);
  }

  openEditDialog(item) {
    this.openEditDialogEmiter.emit(item);
  }

  handleUnfollow(item) {
    this.unfollowEmiter.emit(item);
  }

  moveItem(index: number, offset: number, event: Event) {
    event.stopPropagation();
    const destination = index + offset;
    if (
      this.reordering ||
      destination < 0 ||
      destination >= this.sidebarData.length
    ) {
      return;
    }

    const reordered = [...this.sidebarData];
    [reordered[index], reordered[destination]] = [
      reordered[destination],
      reordered[index],
    ];
    this.reorderEmiter.emit(reordered);
  }

  getItemIcon(item: SidebarList): string {
    if (eq(item.parentName, Content.Topic)) {
      if (eq(item.parentObject?.categoryName, 'Competitor')) {
        return 'pi pi-building';
      }
      if (eq(item.parentObject?.categoryName, 'My Company')) {
        return 'pi pi-flag';
      }
      return 'pi pi-hashtag';
    }
    if (eq(item.parentName, Content.ContentItem)) {
      return 'pi pi-file';
    }
    return 'pi pi-user';
  }

  openNewTopic() {
    this.openNewDialogEmiter.emit();
  }

  openNewContentItem() {}

  goToTitleUrl(url) {
    window.open(url, '_blank');
  }

  private scrollTop() {
    const section = this.contentItemsScroll?.nativeElement.closest('.p-accordion-content');
    if (section) {
      section.scrollTop = 0;
    }
  }
}
